import { Avatar, Drawer, Icon, Layout, Menu } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import { Constant } from "../../config";
import { hideMenuDisplayAction } from "../../store/actions/headerBar";
import {
  fetchMenuAction,
  toggleDrawerMenuAction,
} from "../../store/actions/leftSideMenu";
import "./LeftSide.css";
import { checkRolePermission } from "../../services/permission";
import { permissionName, permissionType } from "../../config/permission";

const { Sider } = Layout;
const { SubMenu } = Menu;

class LeftSide extends Component {
  state = {
    collapsed: false,
    permission: null,
    menu: [],
    canReadHome: false,
    canReadPayment: false,
    canReadSalesOrder: false,
    canActivatePayment: false,
    canReadRevisionPrice: false,
    canReadCountry: false,
    canReadCountryRestrict: false,
    canActivateCountry: false,
    canActivateRevisionPrice: false,
    canReadUserMgmt: false,
    canReadOfferMgmt: false,
    canReadPriceMgmt: false,
    canActivatePriceMgmt: false,
    canReadGatewayMgmt: false,
    canReadSenderPool: false,
    canReadSenderDefault: false,
    canReadSenderGeneric: false,
    canActivateSenders: false,
    canReadSmsLogs: false,
    canReadBlacklistMgmt: false,
    canReadKeyword: false,
    canReadAdminMgmt: false,
    canReadApproveBinding: false,
  };

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  logout = async () => {
    let opt = {
      url: Constant.ADMIN_LOGOUT_API,
      method: "POST",
      headers: {
        Authorization: "Bearer " + localStorage.getItem(Constant.SessionKey),
        "Content-Type": "application/x-www-form-urlencoded",
      },
    };
    let resp;

    try {
      resp = await axios(opt);
    } catch (err) {
      resp = err.response;
    }

    if (!resp.data) {
      console.log(resp);
    } else if (resp.data.error) {
      console.log(resp.data.error);
    }

    localStorage.removeItem(Constant.SessionKey);
    localStorage.removeItem(Constant.MyNameKey);
    this.props.hideMenuDisplayAction();
    window.location.href = "/";
  };

  onMenuMobileClick = (e) => {
    this.props.toggleDrawerMenuAction();

    switch (e.key) {
      case "logout":
        this.logout();
        return;
      default:
    }
  };

  componentWillMount() {
    const canReadPayment = checkRolePermission(
      permissionName.PAYMENT,
      permissionType.READ
    );
    const canReadApproveBinding = checkRolePermission(
      permissionName.SALE_BINDING_REQUEST_MANAGEMENT,
      permissionType.UPDATE
    );
    const canReadSalesOrder = checkRolePermission(
      permissionName.PAYMENT_SO,
      permissionType.READ
    );
    const canActivatePayment =
      canReadPayment || canReadSalesOrder ? true : false;

    const canReadRevisionPrice = checkRolePermission(
      permissionName.REVISION_PRICE,
      permissionType.READ
    );
    const canReadCountry = checkRolePermission(
      permissionName.COUNTRY,
      permissionType.READ
    );
    const canReadCountryRestrict = checkRolePermission(
      permissionName.COUNTRY_RESTRICTION,
      permissionType.READ
    );
    const canActivateCountry =
      canReadCountry || canReadCountryRestrict ? true : false;
    const canActivateRevisionPrice =
      canReadRevisionPrice || canActivateCountry ? true : false;

    const canReadSenderPool = checkRolePermission(
      permissionName.SENDER_POOL,
      permissionType.READ
    );
    const canReadSenderDefault = checkRolePermission(
      permissionName.SENDER_DEFAULT,
      permissionType.READ
    );
    const canReadSenderGeneric = checkRolePermission(
      permissionName.SENDER_GENERIC,
      permissionType.READ
    );
    const canActivateSenders =
      canReadSenderPool || canReadSenderDefault || canReadSenderGeneric
        ? true
        : false;

    this.setState({
      canReadHome: checkRolePermission(
        permissionName.HOME,
        permissionType.READ
      ),
      canReadPayment,
      canReadApproveBinding,
      canReadSalesOrder,
      canActivatePayment,
      canReadRevisionPrice,
      canReadCountry,
      canReadCountryRestrict,
      canActivateCountry,
      canActivateRevisionPrice,
      canReadUserMgmt: checkRolePermission(
        permissionName.CUSTOMER_MANAGEMENT,
        permissionType.READ
      ),
      canReadOfferMgmt: checkRolePermission(
        permissionName.OFFER_MANAGEMENT,
        permissionType.READ
      ),
      canReadPriceMgmt: checkRolePermission(
        permissionName.PRICE_MANAGEMENT,
        permissionType.READ
      ),
      canReadGatewayMgmt: checkRolePermission(
        permissionName.GATEWAY_MANAGEMENT,
        permissionType.READ
      ),
      canReadSenderPool,
      canReadSenderDefault,
      canReadSenderGeneric,
      canActivateSenders,
      canReadSmsLogs: checkRolePermission(
        permissionName.SMS_LOG,
        permissionType.READ
      ),
      canReadBlacklistMgmt: checkRolePermission(
        permissionName.BLACKLIST_MANAGEMENT,
        permissionType.READ
      ),
      canReadKeyword: checkRolePermission(
        permissionName.KEYWORD,
        permissionType.READ
      ),
      canReadAdminMgmt: checkRolePermission(
        permissionName.ADMIN_MANAGEMENT,
        permissionType.READ
      ),
    });
  }

  componentDidMount() {
    this.setState({
      menu: [
        {
          key: "home",
          path: "/",
          iconType: "home",
          name: "Home",
          canActivate: this.state.canReadHome,
          subMenu: [],
        },
        {
          key: "payment",
          path: "",
          iconType: "bank",
          name: "Payment",
          canActivate: this.state.canActivatePayment,
          subMenu: [
            {
              key: "all",
              path: "/payment",
              iconType: "ordered-list",
              name: "Payment List",
              canActivate: this.state.canReadPayment,
              subMenu: [],
            },
            {
              key: "so",
              path: "/so/list",
              iconType: "contacts",
              name: "Sale Order",
              canActivate: this.state.canReadSalesOrder,
              subMenu: [],
            },
          ],
        },
        {
          key: "revision-price",
          path: "",
          iconType: "bar-chart",
          name: "Revision Price",
          canActivate: this.state.canActivateRevisionPrice,
          subMenu: [
            {
              key: "revision-listing",
              path: "/revision-price/listing",
              iconType: "",
              name: "Revision Listing",
              canActivate: this.state.canReadRevisionPrice,
              subMenu: [],
            },
            {
              key: "country",
              path: "",
              iconType: "",
              name: "Country Listing",
              canActivate: this.state.canActivateCountry,
              subMenu: [
                {
                  key: "country",
                  path: "/revision-price/country",
                  iconType: "ordered-list",
                  name: "Country",
                  canActivate: this.state.canReadCountry,
                  subMenu: [],
                },
                {
                  key: "country-restrictions",
                  path: "/revision-price/country-restrictions",
                  iconType: "alert",
                  name: "Restrictions",
                  canActivate: this.state.canReadCountryRestrict,
                  subMenu: [],
                },
              ],
            },
          ],
        },
        {
          key: "user-management",
          path: "",
          iconType: "user",
          name: "Customer Management",
          canActivate: this.state.canReadUserMgmt,
          subMenu: [
            {
              key: "listing",
              path: "/user-management/listing",
              iconType: "user",
              name: "Customer Management",
              canActivate: this.state.canReadUserMgmt,
              subMenu: [],
            },
            {
              key: "smpp-customers-monitoring",
              path: "/user-management/smpp-customers-monitoring",
              iconType: "bar-chart",
              name: "SMPP Monitoring",
              canActivate: this.state.canReadUserMgmt,
              subMenu: [],
            },
          ],
        },
        {
          key: "approve-binding-sales-owner",
          path: "/approve-binding-sales-owner",
          iconType: "check-circle",
          name: "Approve Binding Sales Owner",
          canActivate: this.state.canReadApproveBinding, // edited
          subMenu: [],
        },
        {
          key: "offer",
          path: "/offer",
          iconType: "reconciliation",
          name: "Offer Management",
          canActivate: this.state.canReadOfferMgmt,
          subMenu: [],
        },
        {
          key: "price-management",
          path: "",
          iconType: "calculator",
          name: "Price Management",
          canActivate: this.state.canReadPriceMgmt,
          subMenu: [
            {
              key: "cost-listing",
              path: "/price-management/cost-listing",
              iconType: "",
              name: "Cost Listing",
              canActivate: this.state.canReadPriceMgmt,
              subMenu: [],
            },
          ],
        },
        {
          key: "gateway-management",
          path: "",
          iconType: "diff",
          name: "Gateway Management",
          canActivate: this.state.canReadGatewayMgmt,
          subMenu: [
            {
              key: "gateway-country",
              path: "/gateway-management/gateway-country",
              iconType: "gateway",
              name: "Gateway Route",
              canActivate: this.state.canReadGatewayMgmt,
              subMenu: [],
            },
            {
              key: "gateway-country-logs",
              path: "/gateway-management/gateway-country-logs",
              iconType: "file-text",
              name: "Gateway Logs",
              canActivate: this.state.canReadGatewayMgmt,
              subMenu: [],
            },
          ],
        },
        {
          key: "senders",
          path: "",
          iconType: "credit-card",
          name: "Senders",
          canActivate: this.state.canActivateSenders,
          subMenu: [
            {
              key: "senders-pool",
              path: "/senders/senders-pool",
              iconType: "border-outer",
              name: "Senders Pool",
              canActivate: this.state.canReadSenderPool,
              subMenu: [],
            },
            {
              key: "senders-default",
              path: "/senders/default",
              iconType: "highlight",
              name: "Default",
              canActivate: this.state.canReadSenderDefault,
              subMenu: [],
            },
            {
              key: "senders-default-gateway",
              path: "/senders/default-gateway",
              iconType: "container",
              name: "Generic",
              canActivate: this.state.canReadSenderGeneric,
              subMenu: [],
            },
          ],
        },
        {
          key: "sms-logs",
          path: "",
          iconType: "file-text",
          name: "SMS Logs",
          canActivate: this.state.canReadSmsLogs,
          subMenu: [
            // {
            //   key: "outbound",
            //   path: "/sms-logs/outbound",
            //   iconType: "message",
            //   name: "Outbound",
            //   canActivate: this.state.canReadSmsLogs,
            //   subMenu: [],
            // },
            {
              key: "outbound-v2",
              path: "/sms-logs/outbound/v2",
              iconType: "message",
              name: "Outbound v2",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
            {
              key: "smpp",
              path: "/sms-logs/smpp",
              iconType: "message",
              name: "SMPP",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
            {
              key: "viber",
              path: "/sms-logs/viber",
              iconType: "message",
              name: "VIBER",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
            {
              key: "sl-raw",
              path: "/sms-logs/sl-raw",
              iconType: "message",
              name: "Raw Logs",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
            {
              key: "verify",
              path: "/sms-logs/verify",
              iconType: "shake",
              name: "Verify",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
            {
              key: "sms-logs-blackhole",
              path: "/sms-logs/blackhole",
              iconType: "rest",
              name: "Blackhole",
              canActivate: this.state.canReadSmsLogs,
              subMenu: [],
            },
          ],
        },
        {
          key: "blacklist",
          path: "/blacklist",
          iconType: "desktop",
          name: "Universal Blacklist Number",
          canActivate: this.state.canReadBlacklistMgmt,
          subMenu: [],
        },
        {
          key: "keyword",
          path: "",
          iconType: "font-size",
          name: "Keywords",
          canActivate: this.state.canReadKeyword,
          subMenu: [
            {
              key: "alert",
              path: "/keyword/alert",
              iconType: "alert",
              name: "Alert",
              canActivate: this.state.canReadKeyword,
              subMenu: [],
            },
            // {
            //   key: "alert-whitelist",
            //   path: "/keyword/alert-whitelist",
            //   iconType: "audit",
            //   name: "Alert Whitelist",
            //   canActivate: this.state.canReadKeyword,
            //   subMenu: [],
            // },
            {
              key: "keyword-blackhole",
              path: "/keyword/blackhole",
              iconType: "close-square",
              name: "Blackhole",
              canActivate: this.state.canReadKeyword,
              subMenu: [],
            },
          ],
        },
        {
          key: "whitelist",
          path: "",
          iconType: "font-size",
          name: "Whitelist",
          canActivate: this.state.canReadKeyword,
          subMenu: [
            {
              key: "alert-whitelist-member",
              path: "/keyword/alert-whitelist-member",
              iconType: "solution",
              name: "Whitelisted member",
              canActivate: this.state.canReadKeyword,
              subMenu: [],
            },
            {
              key: "keyword-whitelist-url",
              path: "/keyword/keyword-whitelist-url",
              iconType: "solution",
              name: "Whitelist URL",
              canActivate: this.state.canReadKeyword,
              subMenu: [],
            },
          ],
        },
        {
          key: "admin-management",
          path: "/admin-management",
          iconType: "usergroup-add",
          name: "Admin Management",
          canActivate: this.state.canReadAdminMgmt,
          subMenu: [],
        },
      ],
    });
  }

  render() {
    if (!this.props.headerBarStore.menuDisplay) {
      return "";
    }

    let name = "";
    let nameAbb = "";

    if (this.props.headerBarStore.profileDetail) {
      const { firstname, lastname } = this.props.headerBarStore.profileDetail;
      if (firstname) {
        name = firstname + " " + lastname;

        if (name) nameAbb = name.charAt(0);
      }
    }
    const menuItems = this.state.menu.map((item) => {
      if (!item.canActivate) return null;
      if (item.path) {
        return (
          <Menu.Item key={item.key}>
            <NavLink to={item.path}>
              <Icon type={item.iconType} />
              <span>{item.name}</span>
            </NavLink>
          </Menu.Item>
        );
      } else {
        if (!item.canActivate) return null;
        return (
          <SubMenu
            key={item.key}
            title={
              <span>
                <Icon type={item.iconType} />
                <span>{item.name}</span>
              </span>
            }
          >
            {item.subMenu.map((item) => {
              if (!item.canActivate) return null;
              if (item.path) {
                if (item.key === "so") {
                  return (
                    <Menu.Item key={item.key}>
                      <NavLink to={item.path}>
                        <Icon type={item.iconType} />
                        <span>{item.name}</span>
                      </NavLink>
                    </Menu.Item>
                  );
                }

                return (
                  <Menu.Item key={item.key}>
                    <NavLink to={item.path}>
                      {item.iconType && <Icon type={item.iconType} />}
                      <span>{item.name}</span>
                    </NavLink>
                  </Menu.Item>
                );
              } else {
                if (!item.canActivate) return null;
                return (
                  <SubMenu
                    key={item.key}
                    title={
                      <span>
                        {item.iconType && <Icon type={item.iconType} />}
                        <span>{item.name}</span>
                      </span>
                    }
                  >
                    {item.subMenu.map((item) => {
                      if (!item.canActivate) return null;
                      return (
                        <Menu.Item key={item.key}>
                          <NavLink to={item.path}>
                            <Icon type={item.iconType} />
                            <span>{item.name}</span>
                          </NavLink>
                        </Menu.Item>
                      );
                    })}
                  </SubMenu>
                );
              }
            })}
          </SubMenu>
        );
      }
    });

    return (
      <div style={{ backgroundColor: "#001529" }}>
        {/*--- For Desktop ---*/}
        <Sider
          className="my-left-sider"
          collapsible
          collapsed={this.state.collapsed}
          onCollapse={this.onCollapse}
          width={250}
        >
          <Menu
            mode="inline"
            style={{ height: "100%", borderRight: 0 }}
            theme="dark"
            defaultOpenKeys={[this.props.leftSideMenuStore.menuParentKey]}
            selectedKeys={[this.props.leftSideMenuStore.menuKey]}
          >
            {menuItems}
          </Menu>
        </Sider>

        {/*--- For Mobile ---*/}
        <div>
          <Drawer
            className="my-drawer my-dark"
            title={
              <span>
                <Avatar>{nameAbb}</Avatar>
                <div>{name}</div>
              </span>
            }
            placement="left"
            closable={false}
            onClose={this.props.toggleDrawerMenuAction}
            visible={this.props.leftSideMenuStore.flagDrawerMenu}
          >
            <Menu
              mode="inline"
              style={{ height: "100%", borderRight: 0 }}
              theme="dark"
              defaultOpenKeys={[this.props.leftSideMenuStore.menuParentKey]}
              selectedKeys={[this.props.leftSideMenuStore.menuKey]}
              onClick={(e) => this.onMenuMobileClick(e)}
            >
              {menuItems}
            </Menu>
          </Drawer>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headerBarStore: state.headerBar,
    leftSideMenuStore: state.leftSideMenu,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    hideMenuDisplayAction: () => dispatch(hideMenuDisplayAction()),
    fetchMenuAction: (menuParentKey, menuKey) =>
      dispatch(fetchMenuAction(menuParentKey, menuKey)),
    toggleDrawerMenuAction: () => dispatch(toggleDrawerMenuAction()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(LeftSide);



// WEBPACK FOOTER //
// ./src/containers/LeftSide/index.js